import React from 'react';
import PropTypes from 'prop-types';
import DefaultPicture, {
  propTypes as picturePropTypes,
} from '../../../components/01_atoms/DefaultPicture';
import FormattedText from '../../../components/01_atoms/FormattedText';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../utils/behaviorSettings';

import s from './index.module.scss';

const BBGiftsImpactBlock = ({ items, heading, subheading = '', uuid = null, behaviorSettings }) => {
  const classes = [
    'bb',
    s['bb-gifts-impact-block'],
    generateClassNameByBehaviorSettings(behaviorSettings),
  ];
  return (
    <div className={classes.join(' ')} id={uuid}>
      <div className="container">
        <h3 className={s['bb-gifts-impact-block__heading']}>{heading}</h3>
        <FormattedText text={subheading} className={s['bb-gifts-impact-block__subheading']} />
        <div className={s['bb-gifts-impact-block__items']}>
          {items.map((item, index) => (
            <div className={s['bb-gifts-impact-block__item']} key={`${item.title}-${index}`}>
              <DefaultPicture {...item.image} className={s['bb-gifts-impact-block__item-image']} />
              <h4 className={s['bb-gifts-impact-block__item-title']}>{item.title}</h4>
              <FormattedText
                text={item.description}
                className={s['bb-gifts-impact-block__item-description']}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

BBGiftsImpactBlock.propTypes = {
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      image: PropTypes.shape(picturePropTypes),
    }),
  ).isRequired,
};

export default BBGiftsImpactBlock;
